import classNames from "classnames/bind";
import styles from "./StreamCamera.module.css";
import LiveVideo from "./LiveVideo";
import TablePlate from "./TablePlate";
import DetailInfo from "./DetailInfo";
import { Col, Row } from "../../../../../components";
import React, { useContext, useState, useEffect } from "react";
import { LisencePlateContext } from "../../../../../contexts";
import axiosClient from "../../../../../services/axiosClient";

const cx = classNames.bind(styles);

const StreamCamera = ({ data }) => {
  const { screen, showInfo, info } = useContext(LisencePlateContext);
  const [licenses, setLicenses] = useState([]);
  // useEffect(() => {
  //     const getLincce = async () => {
  //       try {

  //           const res = await axiosClient.get(
  //             "/camALPR/get-list-cam-license-plate/",
  //             {
  //               params: {
  //                 camera_code: data.code,
  //               },
  //             }
  //           );
  //           setLicenses(res.data)
  //           // console.log(res.data);

  //       } catch (e) {}
  //     };
  //     getLincce();
  //   }, [data.code]);
  React.useEffect(() => {
    const eventSource = new EventSource(
      `${process.env.REACT_APP_SSE_LIVE}alpr-sse?token=${sessionStorage.getItem(
        "token"
      )}`
    );
    eventSource.onmessage = (event) => {
      if (JSON.parse(event.data).camera_code === data.code) {
        if (licenses.length <= 100) {
          // console.log(JSON.parse(event.data), 'JSON.parse(event.data)');
          setLicenses([
            {
              CAMERA_IMAGE: JSON.parse(event.data).car_best_image_path,
              LICENSE_PLATE: JSON.parse(event.data).license_plate_text,
              LICENSE_PLATE_IMAGE: JSON.parse(event.data)
                .license_plate_image_path,
              TIME: JSON.parse(event.data).time_detect,
            },
            ...licenses,
          ]);
        } else {
          const max = licenses.length;
          const data = licenses.filter((item, index) => index < max);
          setLicenses([
            {
              CAMERA_IMAGE: JSON.parse(event.data).car_best_image_path,
              LICENSE_PLATE: JSON.parse(event.data).license_plate_text,
              LICENSE_PLATE_IMAGE: JSON.parse(event.data)
                .license_plate_image_path,
              TIME: JSON.parse(event.data).time_detect,
            },
            ...data,
          ]);
        }
      }
    };
    eventSource.onerror = (error) => {
      eventSource.close();
    };
    return () => {
      eventSource.close();
    };
  }, [data, licenses]);
  return (
    <div className={cx("container")}>
      <Row gap={[8, 8]} >
        <Col span={7}>
          <LiveVideo data={data} />
          {screen && screen.total <= 2 && showInfo && (
            <DetailInfo info={info} />
          )}
        </Col>
        <Col span={5}>
          <TablePlate data={licenses} />
        </Col>
      </Row>
    </div>
  );
};

export default StreamCamera;
